module.exports = __webpack_public_path__ + "img/bullet_14.d1304791.svg";